import GeneratedCalendarInboxServiceApi from "./generated/GeneratedCalendarInboxServiceApi"

class CalendarInboxServiceApi extends GeneratedCalendarInboxServiceApi {

}

export const calendarInboxServiceApi = new CalendarInboxServiceApi()
